import { useDynamicParams } from '@/data/hook/useDynamicParams';
import { ListCoursePathFilters } from '@/data/services/coursePathServices';
import { VersioningStatusUIEnum } from '@/enums/VersioningStatus';
import { adaptVersioningUIFilters } from '@/utils/course-path/adaptVersioningUIFilters';
import { getEnumParam } from '@/utils/filters/searchParams';

type PedContentFilterParams = {
  status?: VersioningStatusUIEnum;
};

export default function usePedContentFilter() {
  const { params, updateParams } = useDynamicParams<PedContentFilterParams>();

  const status = getEnumParam(
    params,
    'status',
    Object.values(VersioningStatusUIEnum),
  );

  const setStatus = (value?: VersioningStatusUIEnum) =>
    updateParams({ status: value });

  const filters: ListCoursePathFilters = status
    ? adaptVersioningUIFilters(status)
    : {};

  return { status, setStatus, filters };
}
